import React from 'react';
import styled from 'styled-components';

import RetentionCustomSequencePicker from '../../../../../containers/dashboards/cards/builder/retention/RetentionCustomSequencePicker';
import RetentionExecutionOptionsBar from '../../../../../containers/dashboards/cards/builder/retention/RetentionExecutionOptionsBar';
import RetentionComposeEventSection from '../../../../retention/complex/RetentionComposeEventSection';
import RetentionFilter from '../../../../../containers/dashboards/cards/builder/retention/RetentionFilter';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  height: 100%;
  overflow: auto;
  position: relative;

  .retention-compose-event-selection-container {
    display: flex;
    justify-content: space-between;
    padding-bottom: 15px;
    border-bottom: 1px solid black;
    flex-wrap: wrap;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }

  .retention-custom-sequence-picker-container {
    flex: 1;
  }

  .retention-execution-options-bar-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
`;

const RetentionComposeContainer = (props) => {
  const {
    onFirstEventChange,
    onReturnEventChange,
    events,
    firstEvent,
    returnEvent,
    getEventMetainf,
    unitId,
    showNotValidFields,
  } = props;

  return (
    <StyledDiv>
      <div className="retention-compose-event-selection-container">
        <div>
          <RetentionComposeEventSection
            onEventChange={(event) => onFirstEventChange(event, getEventMetainf(event))}
            events={events}
            event={firstEvent}
            label="First event"
            showNotValidFields={showNotValidFields}
          />
          <div>
            <RetentionFilter event={firstEvent} eventIndex={0} unitId={unitId} />
          </div>
        </div>
        <div>
          <RetentionComposeEventSection
            onEventChange={(event) => onReturnEventChange(event, getEventMetainf(event))}
            events={events}
            event={returnEvent}
            label="Return event"
            showNotValidFields={showNotValidFields}
          />
          <div>
            <RetentionFilter event={returnEvent} eventIndex={1} unitId={unitId} />
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="retention-custom-sequence-picker-container">
          <RetentionCustomSequencePicker unitId={unitId} />
        </div>
        <div className="retention-execution-options-bar-container">
          <RetentionExecutionOptionsBar unitId={unitId} />
        </div>
      </div>
    </StyledDiv>
  );
};

export default RetentionComposeContainer;
